<form [formGroup]="itemForm" (ngSubmit)="submit()">
  <div fxLayout="column">
    <div fxLayout.gt-xs="row wrap" fxLayout="column">
      <div fxFlex="100">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Số điện thoại</mat-label>
          <input
            tabindex="0"
            matInput
            [formControl]="itemForm.controls['phone']"
            required
          />
          <mat-error *ngIf="itemForm.controls['phone'].hasError('required')">
            Trường này là bắt buộc
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="100">
        <ngx-datatable
          class="material ml-0 mr-0 mb-12"
          [rows]="duplicateList"
          [columnMode]="'flex'"
          [headerHeight]="46"
          [scrollbarH]="false"
          [rowHeight]="36"
          [messages]="{ emptyMessage: 'Không có đơn hàng trùng' }"
          (activate)="onActivate($event)"
        >
          <ngx-datatable-column
            name="STT"
            [sortable]="false"
            [flexGrow]="1"
            cellClass="text-center"
            headerClass="text-center"
          >
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">{{
              rowIndex + 1
            }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Tên" [sortable]="false" [flexGrow]="2">
            <ng-template ngx-datatable-cell-template let-row="row">{{
              row["OrderName"]
            }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="Số điện thoại"
            [sortable]="false"
            [flexGrow]="2"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row["OrderMobile"] }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
          name="Sản phẩm"
          [sortable]="false"
          [flexGrow]="3"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row["ProductName"] }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
        name="Người chăm sóc"
        [sortable]="false"
        [flexGrow]="2"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row["UserName"] }}
        </ng-template>
      </ngx-datatable-column>

          <ngx-datatable-column
            name="Mã level"
            [sortable]="false"
            [flexGrow]="2"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row["Code"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="Tên level"
            [sortable]="false"
            [flexGrow]="3"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row["Name"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="Ngày lên đơn"
            [sortable]="false"
            [flexGrow]="3"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row["RegisterDate"] | dateFormat: "dateTimeFull" }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
  <div class="full-width" style="display: flex">
    <button
      mat-raised-button
      color="primary"
      [disabled]="itemForm.invalid"
      class="ml-auto"
      type="submit"
    >
      Kiểm tra
    </button>
  </div>
</form>
